import Box from "@mui/material/Box";

import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import Alert from "@mui/material/Alert";

import CloseIcon from "@mui/icons-material/Close";
import { actionDeleteAlert } from "./AlertRedux";
import dompurify from "dompurify";

const root_ = (theme) => ({
  // Make bigger than LoginDialog.jsx zIndex so that we can show
  // alerts while the login panel is showing.
  zIndex: theme.zIndex.tooltip + 20,
  position: "fixed",
  left: "50%",
  transform: "translateX(-50%)",
});

const alert_ = (theme) => ({
  margin: "2px",
  minWidth: 300,
  "& a": {
    color: "white",
  },
});

const actionButton_ = (theme) => ({
  color: "white",
  border: "1px solid white",
  marginRight: "6px",
});

const close_ = (theme) => ({
  color: "white",
  "& .MuiSvgIcon-root": {
    fontSize: "1.25rem",
  },
});

export default function AlertManager() {
  const alerts = useSelector((state) => state.alertReducer.alerts);

  return (
    <Box sx={root_}>
      {alerts.map((alert) => (
        <AlertItem alert={alert} key={alert.id} />
      ))}
    </Box>
  );
}

function AlertItem({ alert = {} }) {
  const dispatch = useDispatch();

  const { id, title, severity, buttonLabel, onClick, onClose } = alert;

  const onCloseHandler = () => {
    onClose && onClose();
    dispatch(actionDeleteAlert(id));
  };

  return (
    <Alert
      role="region"
      aria-label="alert panel"
      sx={alert_}
      variant="filled"
      severity={severity || "info"}
      action={
        <span>
          {!!buttonLabel && !!onClick && (
            <Button size="small" sx={actionButton_} onClick={onClick}>
              {buttonLabel}
            </Button>
          )}
          {onClose !== false && (
            <IconButton
              aria-label="Close"
              size="small"
              sx={close_}
              onClick={onCloseHandler}
            >
              <CloseIcon />
            </IconButton>
          )}
        </span>
      }
    >
      {/*
      Allow for HTML in our alerts (such as for links).
      Although we always control the content, we still purify it to avoid
      XSS in case things change in the future.
      */}
      <span
        role="region"
        aria-label="alert message"
        dangerouslySetInnerHTML={{
          __html: dompurify.sanitize(title, { ADD_ATTR: ["target", "rel"] }),
        }}
      ></span>
    </Alert>
  );
}
